import React, { useState } from 'react';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/20/solid';

interface TestRightSidebarProps {
    title?: string;
    children?: React.ReactNode;
}

const TestRightSidebar: React.FC<TestRightSidebarProps> = ({ title = 'Test Right Sidebar', children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleSidebar = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <aside
            className={`select-none fixed z-10 top-[4.1rem] h-[calc(99vh-4rem)] right-0 shadow-md border dark:border-gray-500 transition-transform transform duration-200 w-[19rem] bg-white dark:bg-darkbg ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
        >
            <div className="mx-auto bg-gray-100 dark:bg-darkbglight">
                <div className="min-w-0 px-4 pt-2 pb-1">
                    <div className="text-gray-900 dark:text-gray-300 flex items-center space-x-2 justify-center">
                        <h3 className="text-center text-lg font-semibold leading-7 sm:text-base sm:tracking-tight">
                            {title}
                        </h3>
                    </div>
                </div>
            </div>

            <div
                className={`absolute top-10 ${isOpen ? '-left-2 shadow-md' : '-left-4 shadow-xl'} h-16 border border-gray-300 rounded-md flex items-center justify-center cursor-pointer bg-white dark:bg-darkbglight dark:border-gray-500 dark:text-gray-300`}
                onClick={toggleSidebar}
            >
                {isOpen ? <ChevronDoubleRightIcon width={16} /> : <ChevronDoubleLeftIcon width={16} />}
            </div>

            <div className="pb-12 h-full thin-scroll overflow-y-auto w-full flex flex-col items-center mt-2 px-4 text-gray-700 dark:text-gray-200">
                {children || <p className="text-sm text-center">Add your right sidebar content here.</p>}
            </div>
        </aside>
    );
};

export default TestRightSidebar;
